<template>
	<div class="user_box">
		<div class="header">Child Details</div>
		<div class="user_item flex">
			<div class="name">Profile picture:</div>
			<div class="photo">
				<img :src="userInfo.avatar ? imgBaseUrl+userInfo.child_avatar : require('../../../assets/images/icon/photo.png')" alt="">
			</div>
		</div>
		<div class="user_item">First name：{{userInfo.child_first_name}}</div>
		<div class="user_item">Last name：{{userInfo.child_last_name}}</div>
		<div class="user_item">Gender：{{userInfo.gender == 1 ? 'Boy' : 'Girl'}}</div>
		<div class="user_item">Birthday：{{userInfo.birthday}}</div>
		<div class="user_item">Address：{{userInfo.address_line_one}} </div>
		<div class="first_title">Emergency Contact 1</div>
		<div class="user_item">Name:{{userInfo.contact_first_name_one}}{{userInfo.contact_last_name_one}} </div>
		<div class="user_item">Mobile:{{userInfo.contact_mobile_one}}</div>
		<div class="user_item">Email:{{userInfo.contact_email_one}}</div>
		<div class="user_item">Relationship to child：{{userInfo.relationship_child_one}}</div>
		<div class="first_title">Emergency Contact 2</div>
		<div class="user_item">Name:{{userInfo.contact_first_name_two}}{{userInfo.contact_last_name_two}} </div>
		<div class="user_item">Mobile:{{userInfo.contact_mobile_two}}</div>
		<div class="user_item">Email:{{userInfo.contact_email_two}}</div>
		<div class="user_item">Relationship to child：{{userInfo.relationship_child_two}}</div>
		<div class="user_item">Photo Permission:{{userInfo.photo_permission == 1 ? 'Yes' : 'No'}}</div>
		<div class="user_item">Photo Marketing Permission:{{userInfo.photo_marketing_permission == 1 ? 'Yes' : 'No'}}</div>
		<div class="user_item"> Nanny name:{{userInfo.nanny_first_name}}{{userInfo.nanny_last_name}} </div>
		<div class="user_item">Mobile:{{userInfo.nanny_contact}} </div>
		<div class="user_item flex">
			<div class="name">Nanny picture:</div>
			<div class="photo">
				<img :src="userInfo.nanny_avatar ? imgBaseUrl+userInfo.nanny_avatar : require('../../../assets/images/icon/photo.png')" alt="">
			</div>
		</div>
		<div class="user_item">Medical info：</div>
		<!-- <div class="user_item flex align-center">
			<span>Note：</span>
			<div class="picture">
				<img src="../../../assets/images/home1.png" alt="">
			</div>
			
		</div> -->
		<div class="user_item">Allergy：</div>
		<div class="user_item">Note：</div>
		<div class="edit_btn" @click="toEdit">Edit</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				id:'',
				userInfo:{}
			}
		},
		created(){
			this.id = this.$route.query.id;
			this.getDetail()
		},
		methods:{
			getDetail(){
				this.$api.post('user/getChildDetails',{id:this.id},res=>{
					if(res.code == 1){
						this.userInfo = res.data;
					}
				})
			},
			toEdit(){
				this.$router.push({path:'/home/userInfo/editChild',query:{id:this.id}})
			}
		}
	}
</script>

<style lang="scss" scoped>
	.user_box{
		width: 1240px;
		background: #F7F2EB;
		box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
		border-radius: 10px;
		margin-top: 20px;
		margin-left: 20px;
		padding: 0 40px 60px;
		.header{
			width: 100%;
			height: 90px;
			line-height: 90px;
			border-bottom: 1px solid #5C707A;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
		}
		.first_title{
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
			margin-top: 20px;
		}
		.user_item{
			margin-top: 20px;
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #282E30;
			.photo{
				width: 122px;
				height: 122px;
				border-radius: 50%;
				overflow: hidden;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.picture{
				width: 60px;
				height: 60px;
				margin-left: 10px;
				img{
					width: 100%;
					height: 100%;
				}
			}
		}
		.edit_btn{
			width: 181px;
			height: 57px;
			background: #5C707A;
			border-radius: 29px;
			margin-top: 40px;
			line-height: 57px;
			text-align: center;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #F7F2EB;
			cursor: pointer;
		}
	}
</style>